import React, { useState, useEffect, useMemo } from "react";
import NormalTable from "../../../../utility/table/NormalTable.jsx";
import { useTranslation } from "react-i18next";
import CommonComponent from "../../CommonComponent";
import useActionableCondition from "./useActionableCondition";
import usePersistentDateRange from "../../Common/usePersistentDateRange";
import DashboardReady from "../DashboardReady/DashboardReady";
import ActionableConditionCard from "./ActionableConditionCard";
import categorySelectionDynamic from "../../Common/categorySelectionDynamic";
import Tabs from "../TableTab/TableTab";
import ViewTypeSelect from "../ViewTypeSelect";
import { useOption } from "../../../../context/OptionContext.js";
import { usePermissions } from "../../../../context/PermissionContext.js";
import PermissionControlledCard from "../../../../common/PermissionControlledCard.jsx";
import AllowedCard from "../../../../common/AllowedCard.jsx";
import { addColumn } from "../../Common/addColumn.js";

const ActionableCondition = () => {
  const {
    actionableConditionsLoaded,
    loading,
    actionableConditionsSequence,
    actionableConditionsState,
    getActionableConditions,
    selectedTab,
    setSelectedTab,
    tabOptions,
    filteredTabs, combinedTablePermission, canShowTable, combinedPermission,accessDenied
  } = useActionableCondition();
  const { t } = useTranslation();
  const { selectedOption } = useOption();
  const { selectedRange, handleDateChange, formattedStart, formattedEnd } =
    usePersistentDateRange();
  const permission = usePermissions();

  const handleViewTypeChange = (e) => {
    setViewType(e.target.value);
    localStorage.setItem("viewType", e.target.value);
  };
  const handleColumnChange = async(selectedCols, allColumns) =>{
       const formattedColumns = allColumns
          .filter(col => col !== "id")
          .map(col => ({
            key: col,
            visible: selectedCols.includes(col)
          }));
    
        await addColumn({
          data: {
            section_name: "actionable_condition",
            columns: formattedColumns
          }
        });
      getActionableConditions({ formattedEnd, formattedStart, selectedTab });
  }
  const [selectedIds, setSelectedIds] = useState({
    productId: [],
    categoryId: [],
    parentProductId: [],
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [viewType, setViewType] = useState(() => {
    if (
      permission?.data?.actionable_conditions?.view_format?.category_wise?.display &&
      permission?.data?.actionable_conditions?.view_format?.category_wise?.allowed
    ) {
      // localStorage.setItem("viewType", "category");
      return localStorage.getItem("viewType");
    }
    else if (
      permission?.data?.actionable_conditions?.view_format?.product_wise?.display &&
      permission?.data?.actionable_conditions?.view_format?.product_wise?.allowed
    ) {
      // localStorage.setItem("viewType", "product");
      return localStorage.getItem("viewType");
    }
    return ""; // or handle gracefully
  });
  const handlerFns = useMemo(() => [
    getActionableConditions,
  ], [getActionableConditions]);

  const {
    categoryId,
    categoryName,
    handleCategoryClick,
    onBreadcrumbClick,
    handleParentProductClick,
  } = categorySelectionDynamic(
    handlerFns,
    formattedStart,
    formattedEnd,
    selectedTab
  );
  useEffect(() => {
    // Only call if no category is selected (to avoid duplicate call)
      getActionableConditions({ formattedEnd, formattedStart, selectedTab });
  }, [
    formattedStart,
    formattedEnd,
    selectedTab,
    viewType,
    selectedOption?.id,
  ]);
  useEffect(() => {
    setIsButtonDisabled(false); // Re-enable when user changes selection
  }, [selectedIds]);

  const handleSelectionChange = (ids) => {
    const hasNoSelection =
      ids.productId.length === 0 && ids.categoryId.length === 0;

    if (
      selectedIds.productId.length + selectedIds.categoryId.length > 0 &&
      hasNoSelection
    ) {
      window.location.reload();
    }

    setSelectedIds(ids);
  };

  const handleReflectSelection = (e) => {
    e.preventDefault(); // prevents default button behavior
    setIsButtonDisabled(true);
  };

  const dashboardReady = localStorage.getItem("dashboard-ready") === "true";
  if (accessDenied){
    return(
      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
      <AllowedCard/>
      </div>
    )
  }

  const downloadBtnPermission = permission?.data?.actionable_conditions?.table_section?.download_option?.display && permission?.data?.actionable_conditions?.table_section?.download_option?.allowed

  return (
    <>
      <CommonComponent
        defaultRange={selectedRange}
        onRangeChange={handleDateChange}
        categoryName={categoryName}
        categoryId={categoryId}
        onBreadcrumbClick={onBreadcrumbClick}
        viewType={viewType}
      />
      {!dashboardReady ? (
        <DashboardReady />
      ) : (
        <section className="section dashboard actionable-condition py-2">
          <div className="container-fluid">
            <div className="row my-0 gy-4 mx-0">
              <div className="col-12 m-0 p-0">
                <div className="card">
                  <div className="card-body h-auto p-2">
                    <div className="justify-content-between align-items-baseline">
                      <div className="d-flex justify-content-between align-items-center">
                        {/* <h5 className="kpi-heading">
                          {t("sidebar.actionableCondition")}
                        </h5> */}
                        <Tabs
                        tabs={filteredTabs}
                        onChange={(val) => setSelectedTab(val)}
                        />
                        <PermissionControlledCard
                          permission={combinedPermission}
                          colClass="col-0"
                        >
                          <ViewTypeSelect
                            value={viewType}
                            onChange={handleViewTypeChange}
                            permissions={
                              permission?.data?.actionable_conditions?.view_format
                            }
                          />
                        </PermissionControlledCard>
                      </div>

                      {actionableConditionsLoaded &&
                      Array.isArray(actionableConditionsState) &&
                      actionableConditionsState.length === 0 ? (
                      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
                        No data found
                      </div>
                      ) : (
                       ( selectedTab && canShowTable) &&(
                          <PermissionControlledCard
                            permission={
                              combinedTablePermission
                            }
                            colClass="col-12"
                          >
                            <NormalTable
                              tableId="actionableCondition"
                              data={actionableConditionsState}
                              selectedIds={selectedIds}
                              onSelectionChange={handleSelectionChange}
                              prioritizeSelected={isButtonDisabled}
                              onCategoryClick={handleCategoryClick}
                              onParentProductClick={handleParentProductClick}
                              loading={loading}
                              sequence={actionableConditionsSequence}
                              enableSelection={false}
                              downloadBtnPermission={downloadBtnPermission}
                              isProductwiseTable={viewType === 'product'}
                              onColumnChange={handleColumnChange}
                              showSelectColumn={true}
                              section={"actionable_condition"}
                            />
                          </PermissionControlledCard>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {selectedIds.productId.length + selectedIds.categoryId.length > 0 && (
        <button
          className="floating-btn-select"
          onClick={handleReflectSelection}
          disabled={isButtonDisabled}
        >
          ({selectedIds.productId.length + selectedIds.categoryId.length}){" "}
          {t("checkboxSelect.heading")}
        </button>
      )}
    </>
  );
};

export default ActionableCondition;
